import React, { createContext, useState, useContext } from 'react';

// ایجاد Context با یک مقدار اولیه (null) برای جلوگیری از خطای destructure
export const AuthContext = createContext(null);

const isTokenValid = (token) => {
  if (!token) return false;

  try {
    const payload = JSON.parse(
      decodeURIComponent(
        atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))
          .split('')
          .map((character) => `%${character.charCodeAt(0).toString(16).padStart(2, '0')}`)
          .join('')
      )
    );
    return payload.role === 'admin' && (!payload.exp || payload.exp * 1000 > Date.now());
  } catch {
    return false;
  }
};

const getStoredSession = () => {
  const token = localStorage.getItem('admin_token');
  const savedUser = localStorage.getItem('admin_user');

  if (!isTokenValid(token) || !savedUser) {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    return { user: null, token: null };
  }

  try {
    return { user: JSON.parse(savedUser), token };
  } catch {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    return { user: null, token: null };
  }
};

export const AuthProvider = ({ children }) => {
  const [session, setSession] = useState(getStoredSession);

  const login = (userData, token) => {
    if (!userData || !isTokenValid(token)) {
      throw new Error('Invalid admin session');
    }

    setSession({ user: userData, token });
    localStorage.setItem('admin_user', JSON.stringify(userData));
    localStorage.setItem('admin_token', token);
  };

  const logout = () => {
    setSession({ user: null, token: null });
    localStorage.removeItem('admin_user');
    localStorage.removeItem('admin_token');
  };

  return (
    <AuthContext.Provider
      value={{
        user: session.user,
        token: session.token,
        isAuthenticated: Boolean(session.user && session.token),
        login,
        logout,
      }}>
      {children}
    </AuthContext.Provider>
  );
};

// یک Hook ساده می‌سازیم تا استفاده راحت‌تر شود و خطا ندهد
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used inside AuthProvider');
  }
  return context;
};
